<template>
  <div v-if="isVisible" class="app-preloader">
    <div class="preloader-content">
      <div class="logo-container">
        <img :src="logoSrc" alt="Opera Game App" class="app-logo" />
      </div>
      <div class="loading-animation">
        <div class="spinner"></div>
      </div>
      <div class="loading-text">Loading Game Assets...</div>
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: progress + '%' }"></div>
      </div>
      <div class="progress-text">{{ Math.round(progress) }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPreloader',
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      logoSrc: require("../assets/images/logo.png")
    }
  }
}
</script>

<style scoped>
.app-preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #000 0%, #1a1a2e 50%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.5s ease-in-out;
}

.preloader-content {
  text-align: center;
  color: #fff;
  max-width: 300px;
  width: 90%;
}

.logo-container {
  margin-bottom: 30px;
}

.app-logo {
  max-width: 150px;
  height: auto;
  animation: pulse 2s infinite;
}

.loading-animation {
  margin-bottom: 20px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #570065;
  border-radius: 50%;
  margin: 0 auto;
  animation: spin 1s linear infinite;
}

.loading-text {
  font-family: 'Angkor', serif;
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
  letter-spacing: 0.5px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #570065, #27d267);
  border-radius: 4px;
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(87, 0, 101, 0.5);
}

.progress-text {
  font-family: 'Angkor', serif;
  font-size: 14px;
  color: #27d267;
  font-weight: bold;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { 
    transform: scale(1);
    opacity: 1;
  }
  50% { 
    transform: scale(1.05);
    opacity: 0.8;
  }
}
</style>